import axios from 'axios'
import { BASE_API } from '@/api/v1'

const authHeader = () => {
  const token     = window.localStorage.getItem('accessToken')
  const tokenType = window.localStorage.getItem('tokenType')
  return { Authorization: `${tokenType} ${token}` }
}

export default {
  namespaced: true,

  state: {
    active: false,
    message: '',
    loaded: false,
  },

  mutations: {
    SET_STATE(state, { active, message }) {
      state.active = active
      state.message = message
      state.loaded = true
    },
  },

  actions: {
    async fetch({ commit }) {
      try {
        const res = await axios.get(`${BASE_API}/configuracion`, { headers: authHeader() })
        commit('SET_STATE', {
          active: !!res.data.maintenance_mode,
          message: res.data.maintenance_message || '',
        })
      } catch (e) {
        // Si falla, no bloqueamos (fail-open): dejamos loaded=false para reintentar.
      }
    },

    async setMaintenance({ commit }, { activo, mensaje }) {
      const res = await axios.post(
        `${BASE_API}/configuracion/maintenance`,
        { activo, mensaje },
        { headers: authHeader() },
      )
      commit('SET_STATE', {
        active: !!res.data.maintenance_mode,
        message: res.data.maintenance_message || '',
      })
      return res.data
    },
  },
}
